import React, { useEffect, useRef, useState } from "react";

import "@sendbird/uikit-react/dist/index.css";
import { useChannelListContext } from "@sendbird/uikit-react/ChannelList/context";
import "./Chat.css";
import useSendbirdStateContext from "@sendbird/uikit-react/useSendbirdStateContext";
import { sendbirdSelectors } from "@sendbird/uikit-react";
import { useChannelContext } from "@sendbird/uikit-react/Channel/context";
import Message from "./components/Message/Message";
import moment from "moment";
import HttpClient from "../../lib/HttpClient";

import ReplyIcon from "@material-ui/icons/Reply";

import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useSnackbarContext } from "../../contexts/Snackbar";

function formatTimestamp(timestamp) {
  const inputDate = moment(timestamp);

  const today = moment();
  today.startOf("day"); // Set to the start of the day

  if (inputDate.isSameOrAfter(today, "day")) {
    // Format the time in "LT" format
    return moment(timestamp).format("LT");
  } else {
    // Format the date in "DD/MM/YYYY" format
    return moment(timestamp).format("DD/MM/YYYY");
  }
}

const toggleChatFileUploadApi = async (channelId, isEnable) => {
  const URL = `/api/v1/chat/channel/${channelId}/file/${
    isEnable ? "enable" : "disable"
  }`;
  try {
    const response = await HttpClient.performPut(URL);

    return response.body;
  } catch (e) {}
};

const transferChat = async (channelId) => {
  const URL = `/api/v1/chat/transfer/${channelId}`;
  try {
    const response = await HttpClient.performPut(URL);

    return response.body;
  } catch (e) {}
};

const markAsAdminMessageApiRequest = async (channelId, messageId) => {
  const URL = `/api/v1/chat/transfer/admin/${channelId}/${messageId}`;
  try {
    const response = await HttpClient.performPut(URL);
    return response.body;
  } catch (e) {}
};

const processChannelObject = (channelObject) => {
  return typeof channelObject === "string"
    ? channelObject
        .replaceAll("'", '"')
        .replaceAll("True", "true")
        .replaceAll("False", "false")
        .replaceAll("None", "null")
    : channelObject;
};

const selectFirstChannelFromChannelList = (allChannels, setChannel) => {
  if (allChannels.length == 0) {
    return;
  }
  const channel_item = allChannels[0];

  const isDataString = typeof channel_item.data === "string";

  const reformattedData = isDataString
    ? processChannelObject(channel_item.data)
    : channel_item.data;

  const data =
    isDataString && reformattedData !== ""
      ? JSON.parse(reformattedData)
      : reformattedData;

  setChannel({ ...channel_item, data: data });
};

const Chat = ({ data, channel, setChannel, profile, accessToken, appId }) => {
  const {
    allChannels,
    currentChannel,
    loading: channelLoading,
    initialized,
  } = useChannelListContext();

  const { setSnackbar } = useSnackbarContext();

  const globalStore = useSendbirdStateContext();

  const navigate = useNavigate();

  const channelState = useChannelContext();

  const sdkInstance = sendbirdSelectors.getSdk(globalStore);

  // const messageListRef = useRef(null);

  const [isFileUploadEnabled, setIsFileUploadEnabled] = useState(
    channel?.data?.fileUpload
  );

  const markAsAdminMessageCallback = (messageId) => {
    markAsAdminMessageApiRequest(channelState.channelUrl, messageId)
      .then((response) => {
        response?.status?.success == false &&
          setSnackbar({
            message: "Failed to mark message as admin.",
            severity: "error",
          });
      })
      .catch(() =>
        setSnackbar({
          message: "Failed to mark message as admin.",
          severity: "error",
        })
      );
  };

  const scrollToBottom = (channelState) => {
    channelState.scrollRef.current.scrollTop =
      channelState.scrollRef.current.scrollHeight;
  };

  useEffect(() => {
    if (allChannels.length <= 0) {
      if (channel !== undefined) setChannel(undefined);
      return;
    }
    if (
      channel === undefined ||
      !allChannels.some((item) => {
        return item._url === channelState.channelUrl;
      })
    ) {
      selectFirstChannelFromChannelList(allChannels, setChannel);
    }
  }, [allChannels]);

  useEffect(() => {
    if (channelState.allMessages.length === 0) return;
    if (
      channelState.currentGroupChannel.lastMessage?.sender.userId === profile
    ) {
      scrollToBottom(channelState);
    }
  }, [channelState.allMessages]);

  const previousMessageDate = useRef();
  // const sendMessage = sendbirdSelectors.getSendUserMessage(globalStore);

  useEffect(() => {
    previousMessageDate.current = undefined;
  }, [channel]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    setIsFileUploadEnabled(channel?.data?.fileUpload);
  }, [channel]);

  if (channelLoading) {
    return (
      <div
        className="mainContentCointainer"
        style={{
          margin: "20px",
          marginTop: "100px",
          height: "85vh",
          width: "96vw",
          backgroundColor: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
        }}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <>
      {/* <div style={{ marginTop: "100px", height: "90vh" }} className="App">
        <SendbirdApp
          // Add the two lines below.
          appId="95013AC2-E6DE-4914-B2E9-071E8F0B8B0A" // Specify your Sendbird application ID.
          userId="DR000001" // Specify your user ID.
        />
      </div> */}

      <div className="mainContentCointainer">
        {!channelLoading && allChannels.length == 0 && (
          <div className="overlay">
            <div className="info-block">
              <span className="no-messages">No messages from patients</span>
            </div>
          </div>
        )}
        <div className="channel_list_container">
          <ul className="channel_list">
            {allChannels.map((channel_item) => {
              const isDataString = typeof channel_item.data === "string";

              const reformattedData = isDataString
                ? processChannelObject(channel_item.data)
                : channel_item.data;

              const data =
                isDataString && reformattedData !== ""
                  ? JSON.parse(reformattedData)
                  : reformattedData;

              const isActive =
                channel_item._url == (channel ? channel._url : null);

              return (
                <div
                  key={channel_item._url}
                  style={{ display: "flex", position: "relative" }}
                >
                  <li
                    className={
                      isActive
                        ? "channel active"
                        : channel_item.unreadMessageCount > 0
                        ? "channel bold"
                        : "channel"
                    }
                    onClick={() => setChannel({ ...channel_item, data: data })}
                  >
                    {data["name"]}

                    {channel_item.lastMessage.sender.userId === profile && (
                      <span
                        className={
                          isActive ? "is-replied active" : "is-replied"
                        }
                      >
                        {<ReplyIcon />} Replied
                      </span>
                    )}
                    <span
                      className={
                        isActive
                          ? "last-message-time active"
                          : "last-message-time"
                      }
                    >
                      {formatTimestamp(channel_item.lastMessage.createdAt)}
                    </span>
                  </li>

                  {isActive && <span className="channel-arrow"></span>}
                </div>
              );
            })}
          </ul>
        </div>
        <div className="channelContainer">
          <div className="channelHeader">
            <div>
              <span>Patient Name:</span>
              <span style={{ fontWeight: "bold" }}>{channel?.data?.name}</span>
            </div>
            <div>
              <span>Registration No:</span>
              <span style={{ fontWeight: "bold" }}> {channel?.data?.id}</span>
            </div>
            <div>
              <span>Contact No:</span>
              <span style={{ fontWeight: "bold" }}>
                {channel?.data?.mobile}
              </span>
            </div>
          </div>
          {channelState.loading ? (
            <div class="d-flex h-100 w-100 justify-content-center align-items-center">
              <Spinner />
            </div>
          ) : (
            <div className="messageList" ref={channelState.scrollRef}>
              {channelState.allMessages.map((message) => (
                <Message
                  key={message.messageId}
                  message={message}
                  isFromAdmin={message?.sender?.userId.startsWith("CC")}
                  previousMessageDate={previousMessageDate}
                  markAsAdminMessageCallback={markAsAdminMessageCallback}
                />
              ))}
            </div>
          )}
          <div
            style={{
              width: "100%",
              flexDirection: "column",
            }}
          >
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type here..."
              className="messageTextInput"
              ref={channelState.messageInputRef}
            ></textarea>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              {/* <button
                className="btn btn_outline"
                onClick={async () => {
                  const toggleResponse = await toggleChatFileUploadApi(
                    channel._url,
                    !isFileUploadEnabled
                  );
                  toggleResponse?.status?.success
                    ? setIsFileUploadEnabled(
                        (isFileUploadEnabled) => !isFileUploadEnabled
                      )
                    : setSnackbar({
                        message: "Failed to toggle file upload.",
                        severity: "error",
                      });
                }}
              >
                {isFileUploadEnabled ? "Disable" : "Enable"} File Upload
              </button> */}

              <button
                className="btn btn_primary"
                onClick={() => {
                  if (message.trim().length > 0) {
                    channelState.sendMessage({ message: message });
                    setMessage("");
                  } else {
                    setSnackbar({
                      message: "Message cannot be empty.",
                      severity: "error",
                    });
                  }
                }}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Chat;
